import { h } from 'preact';
import * as BaseComp from 'components/shared/footer/footer.js';
import s from 'components/shared/footer/footer.sss';

export default class Footer extends BaseComp.default {

	getStudioLink() {
		let top = super.getStudioLink();

	 // let url = 'https://greenwichentertainment.us17.list-manage.com/subscribe/post?u=66fa7b2b379ec4c844d7dcb0f&amp;id=dd79c46fc9';
		let url = 'https://greenwichentertainment.us17.list-manage.com/subscribe/post?u=66fa7b2b379ec4c844d7dcb0f&amp;id=57ce046cdd'
		let u = '66fa7b2b379ec4c844d7dcb0f';
		let id = 'dd79c46fc9';
		let signup = (
			<form class={s.signup} action={url} method="post" name="mc-embedded-subscribe-form" target="_blank" novalidate>
				<label for="mce-EMAIL">SIGN UP FOR UPDATES</label>
				<input type="email" class={s.email} value="" name="EMAIL" id="mce-EMAIL" placeholder="email address" required />
				<input type="text" class={s.hidden} name={'b_'+u+'_'+id} tabindex="-1" value="" aria-hidden="true" />
				<input type="submit" class={s.button} value="Subscribe" name="subscribe" />
			</form>
		);

		return [].concat(signup, top);
	}

}